<fieldset [ngStyle]="{'border-color': ( disabled ? 'var(--hover)' : 'var(--on-secondary)')}">
  <legend [ngStyle]="{'color': ( disabled ? 'var(--hover)' : 'var(--on-secondary)')}"><b>{{title | translate}}</b></legend>
  <ng-content></ng-content>
</fieldset>
